<template>
  <input
    type="text"
    class="reseller-input"
    :class="inputSize ? 'reseller-input--' + inputSize : ''"
    v-bind="$attrs"
    ref="input"
    @input="handleInput"
  />
</template>

<script>
export default {
  props: {
    size: String
  },
  computed: {
    inputSize() {
      return this.size;
    }
  },
  methods: {
    focus() {
      this.getInput().focus();
    },
    blur() {
      this.getInput().blur();
    },
    getInput() {
      return this.$refs.input;
    },
    handleInput(event) {
      if (this.isComposing) return;
      if (event.target.value === this.nativeInputValue) return;
      this.$emit('input', event.target.value);
      this.$nextTick(this.setNativeInputValue);
    }
  }
};
</script>

<style></style>
